import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { useFormik } from 'formik';

import {
  PHONE_MASK_FORMAT,
  PHONE_NUMBER_PLACEHOLDER,
  SIGNUP_PATHS,
} from '../../../../constants';
import IconBtn from '../../../../modules/icon-btn/icon-btn';
import UiInput from '../../../../modules/ui/ui-input/ui-input';
import { useAppDispatch } from '../../../../store';
import { setPush } from '../../../../store/actions/app';
import { initRegistration } from '../../../../store/actions/signup';
import FormFooter from '../form-footer/form-footer';
import FormHeader from '../form-header/form-header';
import UserIcon from '../icons/user-icon.svg';

enum FormErrorsStrings {
  PHONE_ERROR = 'Введите корректный номер',
}

const PhoneStep: React.FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [disabledBtn, setDisabledBtn] = useState(false);

  const formState = useFormik({
    initialValues: {
      phone: '',
    },
    onSubmit: (values) => {
      if (values.phone) {
        setDisabledBtn(true);
        dispatch(initRegistration({ phoneNumber: values.phone })).then(
          (action) => {
            if (action.meta.requestStatus === 'fulfilled')
              history.push(SIGNUP_PATHS.CODE);
            else
              dispatch(
                setPush({ message: 'Ошибка при регистрации', type: 'error' })
              );
            setDisabledBtn(false);
          }
        );
      }
    },
    validate: (values) => {
      const errors: Record<string, string> = {};
      if (!values.phone || values.phone.length < 11) {
        errors.phone = FormErrorsStrings.PHONE_ERROR;
      }
    },
  });

  const actionsContent = (
    <>
      <IconBtn
        disabled={disabledBtn}
        onClick={() => {
          formState.handleSubmit();
        }}
        icon={UserIcon}
        title="Продолжить"
        lg
      />
      <Link className="login-form__link" to="/login">
        Войти
      </Link>
    </>
  );

  const footerContent = (
    <p className="login-form__text-sm">
      Нажав «Продолжить», вы даете{' '}
      <a href="https://account.cfa.digital/Согласие на обработку персональных данных.docx">согласие на обработку песональных данных</a>
    </p>
  );

  return (
    <form className="login-form">
      <FormHeader
        bigTitle="Регистрация"
        title="Введите номер телефона"
        text="Ваш номер телефона — это ваш логин на платформе"
      />
      <div className="login-form__body">
        <div className="login-form__container-296">
          <UiInput
            mask={PHONE_MASK_FORMAT}
            name="phone"
            value={formState.values.phone}
            onMaskValueChange={(value) =>
              formState.setFieldValue('phone', value)
            }
            placeholder={PHONE_NUMBER_PLACEHOLDER}
            lg
          />
        </div>
      </div>
      <FormFooter actions={actionsContent} footerText={footerContent} />
    </form>
  );
};

export default PhoneStep;
